import * as React from 'react';
import { SemanticICONS, Button } from 'semantic-ui-react';
import { IconSizeProp } from 'semantic-ui-react/dist/commonjs/elements/Icon/Icon';
import { getI18n } from 'services/i18n-service';
import { translations } from 'types/translations';
import { ErrorMessage } from 'components/error-message';
import { BaseModal } from 'components/base-modal/component';

export interface Props {
  isOpen: boolean;
  title: string;
  message: string;
  icon?: SemanticICONS;
  size?: IconSizeProp;
  object: object;
  errorMessage?: string;
  confirm: (object: object) => void;
  close: () => void;
}

interface State {
  defaultIcon: SemanticICONS;
}

export class ConfirmationModal extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      defaultIcon: 'question circle'
    };
  }

  public render() {
    const i18n = getI18n();

    const modalActionButton = (
      <Button
        className="confirm-button"
        onClick={this.handleAccept}>
        {i18n.t(translations.Confirm)}
      </Button>
    );

    return (
      <BaseModal
        open={this.props.isOpen}
        modalProps={{ className: 'modal' }}
        headerText={this.props.title}
        showHeaderClose={true}
        closeHandler={this.handleClose}
        actionButton={modalActionButton}
      >
        <>
          <p>
            <strong>{this.props.message}</strong>
          </p>
          {this.props.errorMessage &&
            <ErrorMessage message={this.props.errorMessage} />
          }
        </>
      </BaseModal>
    );
  }

  private handleClose = () => {
    this.props.close();
  }

  private handleAccept = () => {
    this.props.confirm(this.props.object);
  }
}


// WEBPACK FOOTER //
// ./src/components/confirmation-modal/component.tsx